<template>
    <div
        :class="containerClass"
    >
        <div
            v-if="isPlaying"
            class="video-player__actions"
        >
            <i
                @click="unpin"
                :class="icon"
            />
            <i
                @click="close"
                class="icon icon-close"
            />
        </div>
        <div
            v-if="!isSignedIn"
            class="video-player__empty"
        >
            <div class="video-player__empty-message">
                {{ $t('login to watch video') | capitalize }}
            </div>
            <button
                @click="$emit('requestLogin')"
                class="btn btn--md btn--w-144 btn__primary"
            >
                {{ $t('login') | capitalize }}
            </button>
        </div>
        <div
            v-if="isDetached"
            class="video-player__empty"
        >
            <div class="video-player__empty-message">
                {{ $t('Video is pinned. You can see details for other '
                    + 'events and still watch your pinned video.') | capitalize }}
            </div>
        </div>
        <div
            v-if="isUnavailable"
            class="video-player__empty"
        >
            <div class="video-player__empty-messageg">
                {{ $t('video not available') | capitalize }}
            </div>
        </div>
        <div
            v-if="isLoading"
            class="video-player__empty"
        >
            <div class="video-player__empty-message">
                <SpinnerBars/>
            </div>
        </div>
        <div
            v-else-if="isClosed"
            class="video-player__empty"
        >
            <button
                @click="$emit('resumePlayback')"
                class="btn btn--md btn--w-144 btn__primary"
            >
                {{ $t('resume video') | capitalize }}
            </button>
        </div>
        <div
            v-if="isNotYetStarted"
            class="video-player__empty"
        >
            <button
                @click="$emit('startPlaying')"
                class="btn btn--md btn--w-144 btn__primary"
            >
                {{ $t('play video') | capitalize }}
            </button>
        </div>
        <VideoPlayer
            v-if="isPlaying"
            :streamUrl="streamUrl"
            :videoType="videoType"
            :rerenderingIndicator="position"
            :isSoundOn="isSoundOn"
            @toggleSound="$emit('toggleSound')"
        />
    </div>
</template>

<script>
    import { StreamState } from '@store/modules/ui/sportOffer/enums';

    export default {
        name: 'VideoContainer',
        inheritAttrs: false,
        props: {
            streamUrl: {
                type: String,
                default: '',
            },
            videoType: {
                type: String,
                default: 'video/mp4',
            },
            state: {
                type: String,
                required: false,
                default: StreamState.NotAvailable,
            },
            isPinned: {
                type: Boolean,
                required: true,
            },
            position: {
                type: [Number, String],
                default: 1,
            },
            isDetached: {
                type: Boolean,
                default: false,
            },
            isSignedIn: {
                type: Boolean,
                default: true,
            },
            isSoundOn: {
                type: Boolean,
                default: true,
            }
        },
        computed: {
            isLoading() {
                return this.isSignedIn && !this.isDetached && this.state === StreamState.Loading;
            },
            isUnavailable() {
                return this.isSignedIn && !this.isDetached && this.state === StreamState.NotAvailable;
            },
            isPlaying() {
                return this.isSignedIn && !this.isDetached && this.state === StreamState.Playing;
            },
            isClosed() {
                return this.isSignedIn && !this.isDetached && this.state === StreamState.Closed;
            },
            isNotYetStarted() {
                return this.isSignedIn && !this.isDetached && this.state === StreamState.NotStarted;
            },
            icon() {
                const classNames = ['icon'];
                if (this.isPinned) {
                    classNames.push('icon-pin_45_filled_right');
                } else {
                    classNames.push('icon-pin_45_right');
                }
                return classNames;
            },
            containerClass() {
                const classNames = ['video-player-container'];
                if (this.isDetached) {
                    classNames.push('video-player-container-detached');
                } else if (this.isUnavailable || !this.isSignedIn) {
                    classNames.push('video-player-container-unavaliable');
                } else if (this.isPinned) {
                    classNames.push('video-player-container-docked');
                } else {
                    classNames.push('video-player-container-floating');
                }
                return classNames;
            }
        },
        methods: {
            unpin() {
                this.$emit('videoPinClick');
            },
            close() {
                this.$emit('videoCloseClick');
            }
        },
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/sportOffer/sports/content/components/VideoContainer.vue